import { Component } from '@angular/core';

import { Store } from '@ngrx/store';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { orderData, PaymentFlow, PaymentServiceName } from '@fcom/common-booking';
import { NativeBridgeService } from '@fcom/core/services';
import { profileOrNot } from '@fcom/core/selectors';
import { finShare } from '@fcom/rx';
import { BookingAppState } from '@fcom/common/interfaces/booking';

import { cartData } from '../../../store/selectors';

@Component({
  selector: 'fin-purchase-checkout-route',
  templateUrl: './purchase-checkout-route.component.html',
})
export class PurchaseCheckoutRouteComponent {
  readonly paymentFlow = PaymentFlow.BOOKING;

  serviceName$: Observable<PaymentServiceName>;

  constructor(
    private store$: Store<BookingAppState>,
    private nativeBridgeService: NativeBridgeService
  ) {
    const orderOrCart$ = this.store$.pipe(
      orderData(true),
      finShare(),
      switchMap((order) => (order ? of(order) : this.store$.pipe(cartData())))
    );

    const isCorporateFlow$ = this.store$.pipe(
      profileOrNot(),
      map((profile) => profile?.isCorporate ?? false)
    );

    this.serviceName$ = combineLatest([isCorporateFlow$, orderOrCart$]).pipe(
      map(([isCorporateFlow, orderOrCart]) => {
        if (isCorporateFlow) {
          return 'web_corporate_flow';
        } else {
          const isAwardFlow = !!orderOrCart?.prices?.unpaid?.total?.total?.totalPoints;
          if (this.nativeBridgeService.isInsideNativeWebView) {
            return isAwardFlow ? 'finnairmobileapp_award' : 'finnairmobileapp_booking';
          }
          return isAwardFlow ? 'web_award' : 'finnaircom';
        }
      })
    );
  }
}
